import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import classNames from 'classnames';
import Button from '@helsenorge/designsystem-react/components/Button';
import { Title } from '@helsenorge/designsystem-react/components/Title';
import { getHelsenorgeUrl } from '@helsenorge/framework-utils/hn-proxy-service';
import SearchInput from '../search-input';
import styles from './styles.module.scss';
const SearchBlockWrapper = props => (_jsx("div", { className: styles['searchblock-wrapper'], children: _jsx("div", { className: 'container', children: _jsx("div", { className: 'row', children: _jsx("div", { className: props.hasImage ? 'col col-12' : 'col col-md-10 offset-md-1 col-lg-8 offset-lg-2', children: props.children }) }) }) }));
/**
 * Komponent for søkefelt som går til søkeresultatsiden når man sender inn et søk
 */
const SearchBlock = props => {
    const [inputQuery, setInputQuery] = useState('');
    const [query, setQuery] = useState('');
    const handleInputChange = (q) => {
        setInputQuery(q);
    };
    const handleSubmit = (q, sokekilde) => {
        setInputQuery(q);
        setQuery(q);
        const params = new URLSearchParams(props.queryParams);
        params.set('q', q);
        if (sokekilde) {
            params.set('source', sokekilde);
        }
        else {
            params.delete('source');
        }
        window.location.assign(`${getHelsenorgeUrl()}${props.searchUrl}?${params.toString()}`);
    };
    const searchBlockClasses = classNames(styles.searchblock, !props.wrapper && styles['searchblock--no-wrapper'], props.imageUrl ? styles['searchblock--with-image'] : styles['searchblock--no-image']);
    const block = (_jsxs("div", { className: searchBlockClasses, children: [_jsxs("div", { className: classNames(props.imageUrl && styles.searchblock__mainsection), children: [_jsx(Title, { htmlMarkup: props.titleHtmlMarkup || 'h2', className: styles.searchblock__title, appearance: "title3", children: props.title }), _jsx(SearchInput, { query: inputQuery, searchUrl: props.searchUrl, enableAutosuggest: props.enableAutosuggest, shouldRenderSuggestions: inputQuery !== query, onChange: handleInputChange, onSubmit: handleSubmit, inputAriaLabel: props.inputAriaLabel, containerAriaLabel: props.containerAriaLabel, submitButtonText: props.submitButtonText, invert: true }), props.link && props.linkText && (_jsx(Button, { arrow: 'accessibility-character', variant: 'borderless', onColor: 'ondark', htmlMarkup: 'a', href: props.link, wrapperClassName: styles.searchblock__link, testId: "searchblock-link", children: props.linkText }))] }), props.imageUrl && _jsx("img", { className: styles.searchblock__image, src: props.imageUrl, alt: props.imageAltText })] }));
    if (props.wrapper) {
        return _jsx(SearchBlockWrapper, { hasImage: !!props.imageUrl, children: block });
    }
    return block;
};
export default SearchBlock;
